import { generateClient } from "aws-amplify/data";
import { listSentences } from "../graphql/queries"; // Assuming you have auto-generated queries

// Function to get the total number of items in the Sentences table
export async function getTotalSentences() {
  // Generate an Amplify client
  const client = generateClient();

  let totalCount = 0;
  let nextToken = null; // Token for paginated queries

  try {
    // Paginated query to fetch all sentences
    do {
      const response = await client.graphql({
        query: listSentences, // The query to list sentences
        variables: {
          limit: 1000, // Adjust this limit as necessary
          nextToken: nextToken, // For pagination
        },
      });

      // Get the items from the response
      const items = response.data.listSentences.items;

      // Add the number of items fetched in this iteration to the total count
      totalCount += items.length;

      // Update the nextToken to fetch the next set of items if they exist
      nextToken = response.data.listSentences.nextToken;
    } while (nextToken); // Continue until there are no more items to fetch
  } catch (error) {
    // Log any errors that occur during the fetch
    console.log("Failed to fetch sentences:", error);
  }

  // Return the total count of sentences
  return totalCount;
}

// Function to get a random sentence from the Sentences table
export async function getRandomSentence() {
  // Get the total number of sentences
  const totalCount = await getTotalSentences();

  if (totalCount === 0) {
    return null; // No sentences available
  }

  // Generate a random number to select a random record (between 0 and totalCount - 1)
  const randomIndex = Math.floor(Math.random() * totalCount);

  // Generate an Amplify client
  const client = generateClient();
  let nextToken = null;
  let selectedSentence = null;

  try {
    let currentIndex = 0;
    // Paginated query to fetch all sentences and find the one at randomIndex
    do {
      const response = await client.graphql({
        query: listSentences,
        variables: {
          limit: 1000, // Fetch 1000 records at a time (or adjust the limit)
          nextToken: nextToken,
        },
      });

      const items = response.data.listSentences.items;

      // Check if the randomIndex falls within this batch of items
      if (
        randomIndex >= currentIndex &&
        randomIndex < currentIndex + items.length
      ) {
        // If yes, select the sentence at the corresponding index
        selectedSentence = items[randomIndex - currentIndex];
        break; // Exit the loop as we found the sentence
      }

      // Update the nextToken for the next set of items if they exist
      nextToken = response.data.listSentences.nextToken;
      currentIndex += items.length;
    } while (nextToken && selectedSentence === null);
  } catch (error) {
    console.log("Failed to fetch random sentence:", error);
  }

  return selectedSentence; // Return the randomly selected sentence
}
